import { from } from "rxjs";
import { switchMap, take } from "rxjs/operators";
import { utilBuildings } from "../../../utils/utilBuildings";
import { actionModalCloseAll } from "../../modals/actionModal";
import { actionViewportCenterOn } from "../../viewport/actionViewport";
import { selectBuildingMaxStage } from "../selectors/selectBuildingMaxStage";
export var createPathFocusBuildingMaxLevel = function (getBuildings) { return function (action, state$, deps) {
    return deps.inStoreDependencies.viewportChanged$.pipe(take(1), switchMap(function (viewport) {
        var buildings = getBuildings(action, state$, deps);
        var maxLevelBuilding = selectBuildingMaxStage(buildings);
        var origin = utilBuildings.getCenterPositionOnScreen(maxLevelBuilding, viewport);
        var actions = [actionModalCloseAll(), actionViewportCenterOn(origin)];
        return from(actions);
    }));
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/path/createPathFocusBuildingMaxLevel.ts
// module id = 257
// module chunks = 3